import { WidgetSummary } from '../../utils/widgetSummary';
import './WidgetSelectionMenu.css';

// interface removed
//   widgets: WidgetSummary[];
//   onSelect: (widgetId) => void;
//   onCancel: () => void;
// }

/**
 * Component for selecting an element or panel when multiple matches are found
 */
export function WidgetSelectionMenu({ widgets, onSelect, onCancel }) {
  const getWidgetTypeIcon = (type) => {
    switch (type) {
      case 'metric':
        return '📊';
      case 'line-chart':
        return '📈';
      case 'bar-chart':
        return '📊';
      case 'table':
        return '📋';
      case 'insight':
        return '💡';
      default:
        return '📦';
    }
  };

  const getWidgetTypeLabel = (type) => {
    switch (type) {
      case 'metric':
        return 'Metric Card';
      case 'line-chart':
        return 'Line Chart';
      case 'bar-chart':
        return 'Bar Chart';
      case 'table':
        return 'Table';
      case 'insight':
        return 'Insight';
      default:
        return 'Element';
    }
  };

  return (
    <div className="widget-selection-menu">
      <div className="widget-selection-header">
        <h4>Which element would you like to edit?</h4>
        <p className="widget-selection-subtitle">
          {widgets.length} panel{widgets.length !== 1 ? 's' : ''} found
        </p>
      </div>
      
      <div className="widget-selection-list">
        {widgets.map((widget) => (
          <button
            key={widget.id}
            className="widget-selection-item"
            onClick={() => onSelect(widget.id)}
          >
            <div className="widget-selection-item-icon">
              {getWidgetTypeIcon(widget.type)}
            </div>
            <div className="widget-selection-item-content">
              <div className="widget-selection-item-title">{widget.title}</div>
              <div className="widget-selection-item-type">
                {getWidgetTypeLabel(widget.type)}
              </div>
              <div className="widget-selection-item-description">{widget.description}</div>
              {widget.position && (
                <div className="widget-selection-item-position">
                  Position: Row {widget.position.row}, Column {widget.position.col}
                </div>
              )}
            </div>
          </button>
        ))}
      </div>

      <div className="widget-selection-actions">
        <button className="widget-selection-cancel-btn" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}

